import { ViewConfig } from './types';

export const VIEW_CONFIGS: Record<string, ViewConfig> = {
  territorialPilot: {
    lines: [
      {
        items: [
          {
            key: 'cleanVpYest',
            label: 'profitYesterday',
            format: { maximumFractionDigits: 0 },
          },
          {
            key: 'profitCost',
            label: 'costProfit',
            format: { maximumFractionDigits: 0 },
          },
        ],
      },
    ],
  },
  nonTerritorialNonPilot: {
    main: [
      {
        key: 'revenue',
        label: 'revenue',
        format: { maximumFractionDigits: 0 },
      },
    ],
    lines: [
      {
        items: [
          {
            key: 'profit',
            label: 'profit',
            format: { maximumFractionDigits: 0 },
          },
          {
            key: 'markup',
            label: 'markup',
            format: { maximumFractionDigits: 1 },
            suffix: '%',
          },
        ],
      },
    ],
  },
  territorial: {
    lines: [
      {
        items: [
          {
            key: 'cleanVpYest',
            label: 'profitYesterday',
            format: { maximumFractionDigits: 0 },
          },
          {
            key: 'profitCost',
            label: 'costProfit',
            format: { maximumFractionDigits: 1 },
          },
        ],
      },
    ],
  },
};

export const FORMAT = {
  small: { maximumFractionDigits: 2 },
  compact: {
    maximumFractionDigits: 0,
    notation: 'compact' as const,
    compactDisplay: 'short' as const,
  },
  compact1: {
    maximumFractionDigits: 1,
    notation: 'compact' as const,
    compactDisplay: 'short' as const,
  },
  integer: { maximumFractionDigits: 1 },
  percent: { maximumFractionDigits: 1 },
} as const;

export const NUMBER_STYLE = {
  small: {
    fontSize: '0.7rem',
    fontWeight: 1000,
  },
  big: {
    fontSize: '1.2rem',
    fontWeight: 1000,
  },
  red: {
    fontSize: '1.2rem',
    fontWeight: 1000,
    color: '#ef5350',
  },
} as const;
